import { createContext, useContext } from "react";

import { User } from "../../../models/Person";
import { JourneyType } from "../types/interviewSession";

export type IntakeProfileState = {
  journey: JourneyType;
  profile: User | null;
  isSurveyForm: boolean;
};

const defaultState: IntakeProfileState = {
  journey: "corporate",
  profile: null,
  isSurveyForm: false,
};

export const IntakeProfileContext =
  createContext<IntakeProfileState>(defaultState);

export function useIntakeProfile(): IntakeProfileState {
  return useContext(IntakeProfileContext);
}
